import { FeedbotThunk } from '../../../store/types'
import { featureValueSelector } from '../../../store/features/selectors'
import { feedbotToast } from '../../../lib/feedbotToast'
import { promptForBotNameAndId } from '../../../lib/prompt'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { lastVersionStringForCurrentBotSelector } from '../../../store/socketServer/selectors'
import { endpointHelpers } from '../endpointHelpers'
import { confirm } from '../../../lib/bootbox'
import { switchBot } from '../../../lib/navigation'
import { openBotIdSelector } from '../../../store/app/selectors'

export const initiateBotDuplicationProcess = (): FeedbotThunk => (dispatch, getState) => {
  const generatedNameMode = featureValueSelector('GENERATE_BOT_NAME')(getState())

  if (!generatedNameMode) {
    dispatch(initiateLegacyBotDuplication())
    return
  }

  dispatch(
    modalsActions.openModal({
      type: 'create_bot_settings',
      openSection: 'form',
      creationType: 'duplicate'
    })
  )
}

function initiateLegacyBotDuplication(promptTitle: string = 'Enter bot name'): FeedbotThunk {
  return async (dispatch, getState) => {
    const currentBotId = openBotIdSelector(getState())
    const currentBotVersion = lastVersionStringForCurrentBotSelector(getState())

    const queryResult = await endpointHelpers.getBotsMetadata.initiate()(dispatch, getState)

    if (!queryResult.data) {
      return feedbotToast.error({
        title: 'Failed to initiate bot duplication process',
        content: 'List of existing bots could not be fetched'
      })
    }

    if (!currentBotVersion) {
      // I hope this can never happen
      return feedbotToast.error({
        title: 'Failed to initiate bot duplication process',
        content: 'Current bot version is missing'
      })
    }

    const nameAndId = await promptForBotNameAndId(
      queryResult.data,
      { allowReserved: false, allowCurrent: false, allowExisting: true },
      promptTitle
    )

    if (nameAndId?.id === currentBotId) {
      dispatch(
        initiateLegacyBotDuplication(
          'Provided name cannot be used, because it conflicts with currently selected bot. Please provide a different name'
        )
      )
      return
    }

    if (nameAndId === null) {
      return
    }

    if (queryResult.data.existingBotIds.some(id => id === nameAndId.id)) {
      const isConfirmed = await confirm(
        'Bot with given name already exists. Do you really want to replace it?'
      )

      if (!isConfirmed) {
        return
      }

      await dispatch(
        endpointHelpers.duplicateCurrentVersionToDifferentBot.initiate({
          targetBotId: nameAndId.id,
          versionTitle: `Duplicated from bot ${currentBotId}`
        })
      ).unwrap()

      // If the previous request fails, async fn throws, and no navigation happens :))
      switchBot(nameAndId.id)
    }

    await dispatch(
      endpointHelpers.duplicateCurrentBotToNewBot.initiate({
        newBotId: nameAndId.id,
        categorization: { name: nameAndId.name },
        versionTitle: `Duplicated from bot ${currentBotId}`
      })
    ).unwrap()

    // If the previous request fails, async fn throws, and no navigation happens :))
    switchBot(nameAndId.id)
  }
}
